import * as React from 'react';

export default function useBooted(): void {
    React.useEffect(() => {
        setTimeout(() => {
            document.documentElement.classList.add('booted');
        }, 0);
    }, []);
}
